import {ethers} from 'ethers';
import * as SHA256 from 'crypto-js/sha256';

const WAValidator = require('wallet-address-validator');

export function formatBytes32String(name) {
    return ethers.utils.formatBytes32String(name);
}

export function isAddress(address) {
    return WAValidator.validate(address, 'ETH');
}

export function getAddress(address) {
    return ethers.utils.getAddress(address);
}


/*
 * 以太坊签名
 */
export function sign({params = {}, privateKey}) {
    let signingKey = new ethers.utils.SigningKey(privateKey);
    params.timestamp = parseInt(Date.parse(new Date()) / 1000);

    // 将参数转换成Hash消息
    let tmp = [], str = '';
    for (let i in params) {
        tmp.push(i);
    }
    tmp.sort();
    for (let i in tmp) {
        str += tmp[i] + params[tmp[i]];
    }
    let message = SHA256(str).toString().toUpperCase();

    // 签名
    let messageBytes = ethers.utils.toUtf8Bytes(message);
    let messageDigest = ethers.utils.keccak256(messageBytes);
    let signature = signingKey.signDigest(messageDigest);

    // 将签名结果追加到params中
    params.recoveryParam = signature.recoveryParam;
    params.r = signature.r;
    params.s = signature.s;

    return params;
}